var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 50 50"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "call_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 1.5,
  d: "M0 0h20.461v20.461H0z",
  "data-name": "Rectangle 6975"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19634"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19631",
  transform: "translate(-666 -223)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 25,
  fill: "none",
  "data-name": "Ellipse 1393",
  transform: "translate(666 223)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19457"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#call_svg__a)",
  "data-name": "Group 19456",
  transform: "translate(681 238)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M5.098.846A1.5 1.5 0 0 1 6.16 1.911q.578 1.51 1.141 3.028a2.5 2.5 0 0 1 .116.478.98.98 0 0 1-.553 1.109c-.312.166-.627.328-.947.477a.82.82 0 0 0-.489.719 2.2 2.2 0 0 0 .233 1.24 13.55 13.55 0 0 0 4.924 5.322 9 9 0 0 0 1.371.68 1.53 1.53 0 0 0 .956.03.74.74 0 0 0 .512-.407c.146-.3.3-.587.444-.883a1.05 1.05 0 0 1 1.366-.63c.352.093.692.232 1.035.359q.969.358 1.934.728.248.094.488.208a1.47 1.47 0 0 1 .923.991v.4c-.088.321-.152.65-.268.959a4.25 4.25 0 0 1-2.89 2.72c-.284.084-.582.114-.873.17h-.7c-.283-.045-.567-.08-.846-.136a11 11 0 0 1-3.834-1.716 25.6 25.6 0 0 1-3.9-3.235 25.6 25.6 0 0 1-3.929-4.776A10.4 10.4 0 0 1 1.018 6.58C.946 6.246.903 5.91.846 5.575v-.7a2 2 0 0 0 .035-.159 4.2 4.2 0 0 1 2.733-3.561A9 9 0 0 1 4.695.846Z",
  "data-name": "Path 27326"
})))))));
export { SvgCall as ReactComponent };
export default __webpack_public_path__ + "static/media/call.a3544921686de9a3cb0eca61b730104b.svg";